import { getFirebaseCollectionName, firebaseApp } from '../config/firebase.config';
import { verifyFirebaseAccess } from './firebase';

const STORAGE_USER_PREF = 'firebase_user_prefs';

// Authorise user before reading from firebase
function authAndFetchUserPreferences(environment) {
  return verifyFirebaseAccess(environment).then(res => {
    const firebaseToken = res.data.firebaseToken;
    const uid = res.data.uid;

    const firebaseCollectionName = getFirebaseCollectionName(environment);

    return firebaseApp.auth().signInWithCustomToken(firebaseToken).then(() => {
      const doc = firebaseApp.firestore().collection(firebaseCollectionName).doc(uid);

      return doc ? doc.get() : {};
    }).catch(() => {});
  })
}


// Fetch firebase to get user preferences then save to LocalStorage
function fetchAndSaveToLocalStorage(environment, productName) {
  return new Promise((resolve, reject) => {
    authAndFetchUserPreferences(environment).then((doc) => {
      const prefData = doc ? doc.data()[productName] : undefined;

      const localUserPref = prefData ? {
        [productName]: prefData
      } : null;
      
      if (localUserPref) {
        localStorage.setItem(STORAGE_USER_PREF, JSON.stringify(localUserPref) )
        resolve(localUserPref);
      } else {
        reject('User preferences not set')
      }
    })
  });
}

// Get user preferences from localStorage, if NOT, request that from firebase.
export function getPreferences(environment, productName) {
  const userPref = localStorage.getItem(STORAGE_USER_PREF);
  const hasCorrectProduct = userPref && userPref.indexOf(productName) > -1;

  if (!hasCorrectProduct) {
    localStorage.removeItem(STORAGE_USER_PREF);
  }

  return new Promise((resolve, reject) => {
    if (userPref && hasCorrectProduct) {
      resolve(JSON.parse(userPref));
    } else {
      fetchAndSaveToLocalStorage(environment, productName)
        .then(resolve)
        .catch(reject);
    }
  })
}

// update or create new user preference.
export function updateMyPreference(selectedSuburb, environment) {
  return verifyFirebaseAccess(environment).then(res => {
    const firebaseToken = res.data.firebaseToken;
    const uid = res.data.uid;
    const localUserPref = localStorage.getItem(STORAGE_USER_PREF) || '';

    const isUpdate = localUserPref.indexOf(selectedSuburb.postcode) > -1;
    const firebaseCollectionName = getFirebaseCollectionName(environment);
    const productName = selectedSuburb.productName;

    return firebaseApp.auth().signInWithCustomToken(firebaseToken).then(() => {
      const favouriteSuburb = {
        postcode: selectedSuburb.postcode,
        suburbName: selectedSuburb.localName
      };

      const myPref = {};
      myPref[productName] = JSON.stringify(favouriteSuburb);

      const firebaseDoc = firebaseApp.firestore().collection(firebaseCollectionName).doc(uid);
      localStorage.setItem(STORAGE_USER_PREF, JSON.stringify(myPref));

      /***************
        If firebase doesn't record this: 
          - Review Firebase console -> db -> rules
          - Clear localstorage
          - Remove that collection ID you're testing
      *****************/
      if (isUpdate) {
        return firebaseDoc.update(myPref);
      } else {
        return firebaseDoc.set(myPref);
      }
    }).catch(() => {});
  })
}

